// ==============================|| OVERRIDES - TYPOGRAPHY ||============================== //

import { customTheme } from '../../theme';

export default function Typography() {
  return {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 12,
        },
      },
      variants: [
        {
          props: { variant: 'itemDescription' },
          style: {
            fontSize: '16px',
            fontWeight: 400,
          },
        },
        {
          props: { variant: 'errorText' },
          style: {
            fontWeight: 600,
            fontSize: '14px',
          },
        },
        {
          props: { variant: 'itemPrice' },
          style: {
            fontSize: '18px',
            fontWeight: 400,
          },
        },
        {
          props: { variant: 'labelTotal' },
          style: {
            fontSize: '18px',
            fontWeight: 600,
          },
        },
        {
          props: { variant: 'subTotalPrice' },
          style: {
            fontWeight: 600,
            fontSize: '18px',
            justifyContent: 'center',
            textAlign: 'center',
            alignItems: 'center',
            display: 'flex',
          },
        },
        {
          props: { variant: 'repeatCustomizationTitle' },
          style: {
            fontSize: '18px',
            fontWeight: 600,
            color: '#1A1A1A',
            paddingBottom: '8px',
          },
        },
        {
          props: { variant: 'addOptionsText' },
          style: {
            fontSize: '14px',
            fontWeight: 400,
            color: '#4A4A4A',
          },
        },
        {
          props: { variant: 'labelBold' },
          style: {
            fontWeight: 600,
            fontSize: '14px',
            color: '#4A4A4A',
          },
        },
        {
          props: { variant: 'customisationOptionName' },
          style: {
            fontWeight: 600,
            fontSize: '18px',
          },
        },
        {
          props: { variant: 'requiredText' },
          style: {
            fontWeight: 600,
            fontSize: '14px',
            fontColor: '#000',
          },
        },
        {
          props: { variant: 'itemName' },
          style: {
            fontSize: 16,
            fontWeight: 600,
            color: '#000',
          },
        },
        {
          props: { variant: 'selectOwnChoiceText' },
          style: {
            fontSize: '21px',
            fontWeight: 500,
            color: 'black',
          },
        },
        {
          props: { variant: 'optionName' },
          style: {
            fontSize: '15px',
          },
        },
        {
          props: { variant: 'helperText' },
          style: {
            fontSize: '12px',
            fontWeight: 600,
          },
        },
        {
          props: { variant: 'helperTextLabel' },
          style: {
            fontSize: '18px',
            fontWeight: 600,
          },
        },
        {
          props: { variant: 'patronDetailsLabels' },
          style: {
            fontSize: '16px',
            fontWeight: 500,
          },
        },
        {
          props: { variant: 'email' },
          style: {
            fontSize: '16px',
            fontWeight: 500,
            color: '#2A2A2A',
          },
        },
        {
          props: { variant: 'orText' },
          style: {
            fontSize: '14px',
            fontWeight: 500,
            marginLeft: '10px',
            marginRight: '10px',
          },
        },
        {
          props: { variant: 'regularText' },
          style: {
            fontWeight: 400,
          },
        },
        {
          props: { variant: 'boldText' },
          style: {
            fontWeight: 800,
          },
        },
        {
          props: { variant: 'vendorName' },
          style: {
            fontWeight: 700,
            fontSize: '16px',
            lineHeight: 1.2,
          },
        },
        {
          props: { variant: 'seatValue' },
          style: {
            fontWeight: 500,
            fontSize: '20px',
            color: '#FFFFFF',
          },
        },
        {
          props: { variant: 'orderTrackingText' },
          style: {
            fontWeight: 500,
            fontSize: '20px',
            color: '#2A2A2A',
          },
        },
      ],
    },
  };
}
